// removed by extract-text-webpack-plugin
module.exports = {"row":"Accordion-row-c8198f21","col":"Accordion-col-181a7797","button":"Accordion-button-a391bbfa","bannerAd":"Accordion-bannerAd-ea658ac2","rail":"Accordion-rail-f9fc9f64","Accordion__Wrapper":"Accordion-Accordion__Wrapper-0ed7f369"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FAQs/Accordion/Accordion.scss
// module id = 854
// module chunks = 0